"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_60_0_0 = void 0;
/**
 * Migrate to 60.0.0
 *
 * remove old ID from AE
 * remove Basisartikel from AE
 *
 */
const migration_60_0_0 = (json) => {
    if (json.AEs) {
        json.AEs.forEach((ae) => {
            if (ae.Basisartikel) {
                delete ae.Basisartikel;
            }
        });
    }
    return json;
};
exports.migration_60_0_0 = migration_60_0_0;
//# sourceMappingURL=migration_60_0_0.js.map